import {
  STOCK_MOVEMENT_TYPE_LABELS,
  StockMovementType,
} from '@/enums/StockMovementType';
import { HostToolError } from '../tool-types';
import { getOptionalNumberArray } from '../tool-args';

const VALID_STOCK_MOVEMENT_TYPES = new Set<number>(
  Object.values(StockMovementType).filter(
    (v): v is StockMovementType => typeof v === 'number'
  )
);

const directionTag = (direction: number) =>
  direction > 0 ? 'in' : direction < 0 ? 'out' : 'adjust';

/**
 * Generated from StockMovementType + STOCK_MOVEMENT_TYPE_LABELS so the doc
 * can never drift from the enum. Deterministic (sorted by numeric value) so
 * definition snapshots stay stable.
 */
export const STOCK_MOVEMENT_TYPES_DESCRIPTION = `Stock movement types: ${Array.from(
  VALID_STOCK_MOVEMENT_TYPES
)
  .sort((a, b) => a - b)
  .map((value) => {
    const meta = STOCK_MOVEMENT_TYPE_LABELS[value as StockMovementType];
    return `${value}=${meta.label} (${directionTag(meta.direction)})`;
  })
  .join(', ')}.`;

export const isStockMovementType = (
  value: number
): value is StockMovementType => VALID_STOCK_MOVEMENT_TYPES.has(value);

/** Coerces + validates a movement-type array against the enum. */
export const getOptionalStockMovementTypes = (
  obj: Record<string, unknown>,
  key: string
): StockMovementType[] | null => {
  const nums = getOptionalNumberArray(obj, key, 50);
  if (nums === null) return null;
  const invalid = nums.filter((n) => !isStockMovementType(n));
  if (invalid.length) {
    throw new HostToolError(
      'INVALID_ARGS',
      `Invalid "${key}": unknown movement types`,
      {
        key,
        invalid,
      }
    );
  }
  return nums.filter(isStockMovementType);
};
